import React from 'react';

import {
  useTagsState,
  useTagsActions
} from './TagsContext';

import {
  getTags,
} from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const TagsPageController = () => {
  const tagsState = useTagsState();
  const { onResponse, onError } = useTagsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <PageController
      pageNumber={tagsState?.pageNumber}
      numberOfPages={tagsState?.numberOfPages}
      goToFirstPage={() => {
        getTags({
          onResponse,
          onError,
          pageNumber: 1,
        });
      }}
      goToPreviousPage={() => {
        getTags({
          onResponse,
          onError,
          pageNumber: (tagsState?.pageNumber - 1),
        });
      }}
      goToNextPage={() => {
        getTags({
          onResponse,
          onError,
          pageNumber: (tagsState?.pageNumber + 1),
        });
      }}
      goToLastPage={() => {
        getTags({
          onResponse,
          onError,
          pageNumber: tagsState?.numberOfPages,
        });
      }}
    />
  );
};

export default TagsPageController;
